import useCashPaymentStatus from '@api/hooks/payments/useCashPaymentStatus';
import usePartPaymentStatus from '@api/hooks/payments/usePartPaymentStatus';
import usePendingPaymentStatus from '@layout/PaymentLayout/usePendingPaymentStatus';
import { readCookie } from '@utils/cookies';
import pushRoute from '@utils/pushRoute';
import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

const usePendingPayments = () => {
  const router = useRouter();
  const { goalUID, subscriptionUID } = router.query;

  const isLoggedIn = !!readCookie('accessToken');
  const { pendingPaymentStatus, isLoading: isPendingPaymentStatusLoading } =
    usePendingPaymentStatus(goalUID);

  useEffect(() => {
    if (pendingPaymentStatus && !isEmpty(pendingPaymentStatus.clashDetails)) {
      pushRoute(
        '/goal/[goalSlug]/[goalUID]/subscribe',
        `/goal/-/${pendingPaymentStatus.clashDetails.uid}/subscribe`,
        {},
        '',
        true
      );
    }
  }, [pendingPaymentStatus]);

  const pendingPaymentType = useMemo(() => {
    return (
      pendingPaymentStatus &&
      isEmpty(pendingPaymentStatus.clashDetails) &&
      pendingPaymentStatus.type
    );
  }, [pendingPaymentStatus]);

  useEffect(() => {
    if (
      pendingPaymentType === 'PIP' &&
      pendingPaymentStatus.data.isActivePartSet &&
      pendingPaymentStatus.data.subscriptionUid !== subscriptionUID
    ) {
      pushRoute(
        '/goal/[goalSlug]/[goalUID]/subscribe/[subscriptionUID]',
        `/goal/-/${goalUID}/subscribe/${pendingPaymentStatus.data.subscriptionUid}`,
        {},
        '',
        true
      );
    }
  }, [pendingPaymentStatus, subscriptionUID, goalUID, pendingPaymentType]);

  useEffect(() => {
    if (
      pendingPaymentType === 'PAC' &&
      pendingPaymentStatus.data.subscriptionUid !== subscriptionUID
    ) {
      pushRoute(
        '/goal/[goalSlug]/[goalUID]/subscribe/[subscriptionUID]',
        `/goal/-/${goalUID}/subscribe/${pendingPaymentStatus.data.subscriptionUid}`,
        {},
        '',
        true
      );
    }
  }, [pendingPaymentStatus, subscriptionUID, goalUID, pendingPaymentType]);

  const { partPaymentStatus, isLoading: isPartPaymentStatusLoading } =
    usePartPaymentStatus(pendingPaymentType === 'PIP' ? goalUID : null);
  const { cashResponse, isLoading: isCashPaymentStatusLoading } =
    useCashPaymentStatus(pendingPaymentType === 'PAC' ? goalUID : null);

  const areStatusCallsDone = useMemo(() => {
    return (
      !isLoggedIn ||
      !goalUID ||
      (!isPendingPaymentStatusLoading &&
        (!pendingPaymentType ||
          (pendingPaymentType &&
            ((pendingPaymentType === 'PIP' && !isPartPaymentStatusLoading) ||
              (pendingPaymentType === 'PAC' && !isCashPaymentStatusLoading)))))
    );
  }, [
    isPendingPaymentStatusLoading,
    pendingPaymentType,
    isPartPaymentStatusLoading,
    isCashPaymentStatusLoading,
    isLoggedIn,
    goalUID
  ]);

  return {
    areStatusCallsDone,
    pendingPaymentType,
    partPaymentStatus,
    cashResponse
  };
};

export default usePendingPayments;
